import { Helmet } from 'react-helmet-async';
import Screen from '../Layouts/Screen/Screen';
import ItemList from '../../components/ItemList/ItemList';
import { Bell, ChevronRight, MessageCircle, Paperclip, Smile, UserCheck, UserX } from 'react-feather';
import { BadgeCheck, Megaphone, Server, Trash2 } from 'lucide-react';
import { useAuth } from '../../global-components/src';

const Moderator = () => {
    const { user } = useAuth();
    const canAccessModeratorActions = Boolean(user?.position) || Boolean(user?.id && user.id < 5);
    const hasBrownStamp = user?.stamps?.includes('brown') ?? false;
 
    return (
        <Screen paddingTopTitle title="Moderação">
            <Helmet>
                <title>Paçoca - Moderação</title>
            </Helmet>

            {canAccessModeratorActions && (
                <>
                    <ItemList>
                        <a style={{ color: 'var(--color-text-post)', textDecoration: 'none' }} target="_BLANK" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1jpl6BwHelb0GSOpAVlUVsh1zDSbnG0CxIZAhnlUOZU4/edit?usp=sharing">
                            <UserX className="icon-settings" /> Solicitação de revisão de banimento
                            <ChevronRight className="chevron-right" />
                        </a>
                    </ItemList>

                    <ItemList>
                        <a style={{ color: 'var(--color-text-post)', textDecoration: 'none' }} target="_BLANK" rel="noopener noreferrer" href="https://docs.google.com/spreadsheets/d/1xJ9_R5TBclG5LOssfPJMTwQmRnKgnRU32MjPaE3K_Rc/edit?usp=sharing">
                            <img className="icon-settings" src="/img/selos/autism.png" height="20" alt="" /> Solicitações de selo de autismo
                            <ChevronRight className="chevron-right" />
                        </a>
                    </ItemList>

                    <ItemList link="/moderador/banimentos">
                        <UserX className="icon-settings" /> Usuários Banidos
                        <ChevronRight className="chevron-right" />
                    </ItemList>

                    <ItemList link="/moderador/anuncios">
                        <Megaphone className="icon-settings" /> Anúncios (lista com anúncios pagos que não foram aprovados)
                        <ChevronRight className="chevron-right" />
                    </ItemList>

                    <ItemList link="/usuarios-com-selos">
                        <BadgeCheck className="icon-settings" /> Usuários com selos
                        <ChevronRight className="chevron-right" />
                    </ItemList>

                    <ItemList link="/moderador/requisicoes">
                        <Server className="icon-settings" /> Requisições
                        <ChevronRight className="chevron-right" />
                    </ItemList>

                    <ItemList link="/moderador/posts-ocultos">
                        <Trash2 className="icon-settings" /> Posts Ocultos pelo Paçoca AI
                        <ChevronRight className="chevron-right" />
                    </ItemList>

                    <ItemList link="/moderador/posts-excluidos">
                        <Trash2 className="icon-settings" /> Posts Excluídos
                        <ChevronRight className="chevron-right" />
                    </ItemList>
                </>
            )}

            {hasBrownStamp && (
                <>
                    <ItemList link="/moderador/post-fixado">
                        <Paperclip className="icon-settings" /> Post fixado na rede
                        <ChevronRight className="chevron-right" />
                    </ItemList>

                    <ItemList link="/moderador/emojis">
                        <Smile className="icon-settings" /> Emojis do Paçoca
                        <ChevronRight className="chevron-right" />
                    </ItemList>

                    <ItemList link="/moderador/pacoca-papo">
                        <MessageCircle className="icon-settings" /> Acesso de teste do Paçoca Papo
                        <ChevronRight className="chevron-right" />
                    </ItemList>

                    <ItemList link="/moderador/solicitacoes-selo-empresa">
                        <BadgeCheck className="icon-settings" /> Solicitações de selo black
                        <ChevronRight className="chevron-right" />
                    </ItemList>

                    <ItemList link="/moderador/push">
                        <Bell className="icon-settings" /> Push para todos
                        <ChevronRight className="chevron-right" />
                    </ItemList>
                </>
            )}
        </Screen>
    );
};

export default Moderator;
